"use client";

import { FilterPanel } from "@/components";
import type { WishlistFilters } from "@/types/wishlist";

interface WishlistSidebarProps {
    filters: WishlistFilters;
    onApplyFilters: (filters: WishlistFilters) => void;
    availableBrands: string[];
}

const WishlistSidebar: React.FC<WishlistSidebarProps> = ({
    filters,
    onApplyFilters,
    availableBrands,
}) => {
    return (
        <div className="w-80 flex-shrink-0">
            <div className="-ml-2">
                <FilterPanel
                    onApplyFilters={onApplyFilters}
                    brands={availableBrands}
                    currentFilters={filters}
                    isMobile={false}
                />
            </div>
        </div>
    );
};

export default WishlistSidebar; 